export default __webpack_public_path__ + "static/image-05-480x298-cc4f1d767e3afc1bb5892ff8b6a305a3.jpg";